import { Controller } from "@hotwired/stimulus"

// Shows a hover tooltip only when the `text` target is actually
// truncated (its rendered width exceeds the container width). On
// non-truncated rows the tooltip stays hidden so hovering shorter
// titles doesn't show a redundant pop-up.
//
// Usage:
//   <div data-controller="truncate-tooltip" class="relative group">
//     <div data-truncate-tooltip-target="text" class="truncate">…</div>
//     <div data-truncate-tooltip-target="tip" hidden>…full text…</div>
//   </div>
//
// The tip is hidden via the `hidden` attribute by default; we remove
// it (and let the existing `group-hover:` classes do the show/hide)
// only when the text overflows. Re-checks on window resize so a
// narrower viewport flips short titles into truncation state.
export default class extends Controller {
  static targets = ["text", "tip"]

  connect() {
    this._sync = this._sync.bind(this)
    this._sync()
    window.addEventListener("resize", this._sync)
  }

  disconnect() {
    window.removeEventListener("resize", this._sync)
  }

  _sync() {
    if (!this.hasTextTarget || !this.hasTipTarget) return
    const overflowing = this.textTarget.scrollWidth > this.textTarget.clientWidth + 1
    this.tipTarget.hidden = !overflowing
  }
}
